import upload from './api'
import response from '../../../utils/response'
import { accessorySystemType } from '../../../common/constants'

export default {
  syAccessory: {
    state: {
      accessoryToken: ''
    },
    methods: {
      getToken: {
        timeout: 240,
        handle: function () {
          const $http = window.vueInstantiation.$http
          const api = upload.getAccessoryToken
          return response($http(api.type, api.url, {
            clientType: accessorySystemType
          }))
        }
      }
    }
  }
}
